module.exports = __webpack_public_path__ + "static/media/keyboard-shortcuts.546ab015.svg";